module.exports = __webpack_public_path__ + "static/img/11.a7d86b4.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_right_icon/11.png
// module id = ju2/
// module chunks = 1